export const popUpConstants = {
  INVITED_USER_DELETE: 'Remove access to business and workspaces? This will also free up a seat.'
};


export const popupDismissConstants = {
  POPUP_DISMISS_FAILURE: 'POPUP_DISMISS_FAILURE',
  SET_POPUP_DISMISS: 'SET_POPUP_DISMISS',
  UPDATE_POPUP_DISMISS: 'UPDATE_POPUP_DISMISS',
  POPUP_DISMISS_LOADING: 'POPUP_DISMISS_LOADING',
  POPUP_DISMISS_FINISHED_LOADING: 'POPUP_DISMISS_FINISHED_LOADING',
}